module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/369dbe1e3f2c6a5cbdd73b9826cec7ff.png";